import React, { Component } from 'react';
import { createRoot } from 'react-dom/client';

import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import moment from "moment";

import {
    Button, ButtonGroup, Input, InputGroup, InputGroupText, Label,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Form, Badge, FormFeedback,
    Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Alert, CardFooter
} from "reactstrap";

import Select from 'react-select';

import FilesCustom, { FileUploadModal } from 'components/FilesCustom';

import Dropzone from 'react-dropzone';
import PdfViewer from 'components/PdfViewer';

import Img from 'components/Img';
import * as commonFunc from 'scripts/common';

import { withRouter } from 'components/withRouter';

class ManageFiles extends Component {
    static displayName = ManageFiles.name;

    static models;

    constructor(props) {
        super(props);

        this.customGen = React.createRef(null);

        this.state = { config: null, modelsList: null, files: null, entities: [] };
    }

    componentDidMount() {
        //console.debug("MOUNT");

        var context = this;

        if (this.props.updateUser) this.props.updateUser(function (curUser) {
            context.getContent();
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.searchParams !== prevProps.searchParams) {
            this.getContent();
        }
    }

    getContent() {
        this.setState({ config: null, modelsList: null });
        var context = this;

        commonFunc.getMethod("../api/site/GetSiteModels", { id: -1, categ: "FILES" }).then((responseModel) => {
            var dataModel = responseModel.data;
            if (dataModel.isSuccess && dataModel.result && dataModel.result.models) {
                //var customConfig = JSON.parse(dataModel.result);

                var filesConfig;
                var filteredModels = dataModel.result.models.filter((model) => model.extID === "FILES_CFG");
                if (filteredModels?.length) {
                    filesConfig = JSON.parse(filteredModels[0].value);
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: context.props.i18nManager.t("gal_fail"),
                        html: context.props.i18nManager.t("gal_failLoadModel")
                    });
                }
                var filesModels = {};
                dataModel.result.models.forEach((model) => {
                    filesModels[model.extID] = JSON.parse(model.value);
                });

                var supStates = {};
                if (filesConfig?.entities) supStates.entities = [...filesConfig.entities];

                this.setState({ config: filesConfig, modelsList: filesModels, ...supStates });
            } else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: context.props.i18nManager.t("gal_failLoadModel") + " :<br>" + dataModel.errorMessage
                });
            }
        });
    }

    render() {
        return this.state.config ? (
            <div className="oskala-ged">
                <FolderManager context={this} isShowingEntity={true} entity={"SITE"} defaultFileType={this.state.config.defaultFileType || "GAL"} />
            </div>
        ) : <div>{this.props.i18nManager.t("gal_loadingModule")}</div>;
    }

}

const withI18n = (Component) => {
    return props => {
        const i18n = useTranslation();
        return <Component {...props} i18nManager={{ ...i18n }} />
    }
}

export default withRouter(withI18n(ManageFiles));


function FolderManager(props) {
    var { context, entity, defaultFileType, isShowingEntity } = props;

    var altT = (label, args) => { return (label && label.startsWith("i18n:")) ? context.props.i18nManager.t(label.replace("i18n:", ""), args) : label };
    var customFolderT = (label, args) => { return (label && context.props.i18nManager.t("folder." + label) !== "folder." + label) ? context.props.i18nManager.t("folder." + label) : label };

    const [foldersState, setFoldersState] = React.useState([]);
    const [foldersTreeState, setFoldersTreeState] = React.useState({});

    const [selectedMode, setSelectedMode] = React.useState("list");//TODO : table
    const [filesSorting, setFilesSorting] = React.useState("");

    const [dataCount, setDataCount] = React.useState(0);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [maxPages, setMaxPages] = React.useState(1);

    const [selectedFolderEntity, setSelectedFolderEntity] = React.useState(null);
    const [selectedFolderSiteID, setSelectedFolderSiteID] = React.useState(null);
    const [selectedFolderPath, setSelectedFolderPath] = React.useState(null);
    const [selectedFileID, setSelectedFileID] = React.useState(null);

    const [filesLoading, setFilesLoading] = React.useState(null);
    const [detailsLoading, setDetailsLoading] = React.useState(null);

    const lastSearchReq = React.useRef(0);
    var searchData = { name: "Recherche globale", fileCount: 0, fullPath: "search", siteID: -1, entityPath: "none" };

    React.useEffect(() => {
        setFoldersState([]);
        setFoldersTreeState({});

        setSelectedFolderPath(null);
        setSelectedFolderSiteID(null);
        setSelectedFolderEntity(null);

        document.getElementById("mfilesearch").value = "";
        manageFiles("", null, true, (newFiles) => {
            createTreeFolder(newFiles);
        });
    }, [context.state.entities]);

    React.useEffect(() => {
        if (foldersState?.length) {
            document.getElementById("mfilesearch").value = "";

            var selectedFolder = commonFunc.getValue(foldersTreeState, (selectedFolderPath || ""));
            var isSearch = !selectedFolder && selectedFolderPath;

            if (!isSearch) manageFiles("");
            else {
                setMaxPages(null);
                setDataCount(null);
                setSelectedFileID(null);
                context.setState({ files: [] });
                //sessionStorage.setItem('manageFilesList', "[]");
            }
        }
    }, [selectedFolderPath]);

    React.useEffect(() => {
        if (foldersState?.length) manageFiles(null, true);
    }, [currentPage]);



    function manageFolder(foldersTree, folder, parentRootFolders) {
        var rootFolders = parentRootFolders;
        if (folder.depth === 2 && context.state.config?.preventChildren?.indexOf(folder.name + ";") >= 0) {
            folder.children = null;
        }
        folder.children = folder.children?.filter(child => {
            return !((child.depth === 2 && !commonFunc.isBlank(context.state.config?.includeEntities) && !(context.state.config.includeEntities.indexOf(child.name + ";") >= 0))
                || context.state.config?.excludeFolders?.indexOf(child.fullPath + ";") >= 0);
        });
        folder.children?.forEach((child, index) => {
            if (child.depth >= 2) {
                commonFunc.setValue(foldersTree, child.fullPath, child);

                if (child.depth === 2) child.entityPath = child.name;
                else child.entityPath = folder.entityPath;

                if (!rootFolders) rootFolders = folder.children;
            }

            if (child.depth === 3) child.siteID = child.name;
            else child.siteID = folder.siteID || -1;


            if (child.children?.length) rootFolders = manageFolder(foldersTree, child, rootFolders);
        });
        return rootFolders;
    }

    function createTreeFolder(srcFiles) {
        var args = { searchPattern: "*" };
        args.entities = context.state.entities.length ? context.state.entities?.map(entity => { return { id: 0, value: entity.value, tag: "" }; }) : [];
        args.entities.push({ id: 0, value: "*", tag: "" });
        args.page = 1;
        args.maxPages = 1;
        args.maxItems = -1;
        args.prefix = "*";
        args.categ = "*";
        args.treeOnly = true;
        args.buildTree = true;

        if (context.state.config?.searchFilesArgs) args = { ...args, ...context.state.config.searchFilesArgs };
        args.exclusions = args.exclusions.filter(categ => categ !== "DIR");

        commonFunc.postMethod("../api/data/SearchFiles", args).then((responseFolders) => {
            var dataFolders = responseFolders.data;
            if (dataFolders.isSuccess) {

                //TODO
                var foldersTree = {};
                var rootFolders = manageFolder(foldersTree, dataFolders.extraInfo.tree);
                setFoldersState(rootFolders);
                setFoldersTreeState(foldersTree);

            } else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: context.props.i18nManager.t("gal_failLoadModel") + " :<br>" + dataFolders.errorMessage
                });
            }
        });
    }

    function manageFiles(searchValue, pageChange, resetPath, callback) {
        if (searchValue || searchValue === "") context.setState({ searchValue: searchValue });
        else searchValue = context.state.searchValue;

        if (!pageChange && currentPage !== 1) {
            setCurrentPage(1);
            return;
        }

        context.setState({ files: [] });
        setMaxPages(null);
        setDataCount(null);
        setSelectedFileID(null);

        setFilesLoading(true);

        var selectedFolder = commonFunc.getValue(foldersTreeState, (selectedFolderPath || ""));
        var isSearch = !selectedFolder && selectedFolderPath;

        var isHome = (resetPath || (commonFunc.isBlank(searchValue) && !selectedFolderPath));
        var maxItems = (isHome ? 10 : 500);//5000 TODO

        var args = { searchPattern: searchValue };
        args.entities = context.state.entities.length ? context.state.entities?.map(entity => { return { id: 0, value: entity.value, tag: "" }; }) : [];
        if (!isSearch && !isHome && selectedFolderPath) args.entities.push({ id: 0, value: "*", tag: "" });
        args.maxItems = maxItems;
        if (isSearch && !commonFunc.isBlank(searchValue)) args.prefix = "*";
        else args.prefix = resetPath ? "*" : (selectedFolderPath || "*");
        args.categ = "*";
        args.treeOnly = false;
        args.buildTree = false;
        if (isHome) args.maxPages = 1;
        args.page = currentPage;

        //Recherche uniquement dans le répertoire actuel
        //if (!commonFunc.isBlank(searchValue) && selectedFolder?.depth) args.maxDepth = selectedFolder?.depth;
        if (!isHome && selectedFolder?.children?.length) args.maxDepth = 1;

        if (context.state.config?.searchFilesArgs) args = { ...args, ...context.state.config.searchFilesArgs };

        //treeOnly >> DIR
        //buildTree >> DIR+Files

        //postMethod("../api/data/SearchFiles", {searchPattern:'141_cotedroit_etatlieux.jpg', Prefix:'*',  Page:1, MaxItems:5000, categ:'*', treeOnly:true, buildTree:true, Entities:[]});
        commonFunc.postMethod("../api/data/SearchFiles", args).then((responseFiles) => {
            //commonFunc.getMethod("../api/" + entityG + "/Get" + entityG + "Files", { bindID: 1, fileId: -1 }).then((responseModel) => {
            Swal.close();
            var dataFiles = responseFiles.data;
            if (dataFiles.isSuccess && dataFiles.result) {

                dataFiles.result.forEach(file => {
                    file.length = file.size;
                    file.fileTypeID = file.fileType?.id;
                });

                //TODO : MAJ des infos folder par rapport à la sélection
                /*if (dataFiles.extraInfo?.fileStats && selectedFolder && commonFunc.isBlank(searchValue)) {
                    selectedFolder.fileCount = dataFiles.extraInfo.fileStats.totalFiles;
                    selectedFolder.size = dataFiles.extraInfo.fileStats.totalSize;
                    selectedFolder.sizeFormatted = dataFiles.extraInfo.fileStats.totalSizeFormatted;
                }*/

                var newFiles = dataFiles.result;
                if (context.state.config?.excludeSyncableFiles) newFiles.filter(file => !file.isSyncable);//TODO : A gérer en amont (back) !!!
                context.setState({ files: newFiles });
                //sessionStorage.setItem('manageFilesList', JSON.stringify(newFiles));
                if (dataFiles.extraInfo?.maxPages >= 0) setMaxPages(dataFiles.extraInfo.maxPages);
                if (dataFiles.extraInfo?.totalItems >= 0) setDataCount(dataFiles.extraInfo.totalItems);
                if (callback && typeof (callback) === "function") { callback(newFiles); }
            } else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: dataFiles.errorMessage
                });
            }
            setFilesLoading(null);
        });
    }

    function selectFile(file, directDownload) {
        if (file) {
            setDetailsLoading(true);

            var args = { searchPattern: "*" };
            args.entities = [];
            args.page = 1;
            args.maxPages = 1;
            args.maxItems = 1;
            args.prefix = "*";
            args.categ = "*";
            args.treeOnly = false;
            args.buildTree = false;
            args.generateLink = true;
            args.fileId = file.idFile;
            commonFunc.postMethod("../api/data/SearchFiles", args).then((responseFile) => {
                Swal.close();
                var dataFile = responseFile.data;
                if (dataFile.isSuccess && dataFile.result?.length) {

                    file.absoluteUri = dataFile.result[0].absoluteUri;

                    if (directDownload) {
                        var dt = file;
                        const fileArgs = {
                            fileId: dt.idFile,
                            fileName: dt.name,
                            container: dt.rootContainer,
                            etag: dt.etag,
                            accessToken: dt.absoluteUri,
                            newWindow: false
                        };

                        fileArgs.newWindow = true;
                        var filePathDirectDl = "../api/data/DownloadFileByUri?" + commonFunc.toParams(fileArgs);
                        window.open(filePathDirectDl, '_newself');
                    }
                } else {
                    Swal.fire({
                        icon: "error",
                        title: context.props.i18nManager.t("gal_fail"),
                        html: dataFile.errorMessage
                    });
                }

                setDetailsLoading(null);
                setSelectedFileID(file.idFile);
            });
        }
        else {
            setSelectedFileID(null);
        }
    }

    function removeFile(file) {
        var id = file.idFile || 0;
        var title = commonFunc.cellFormatterFileType(file.name);
        if (id > 0) {
            Swal.fire({
                icon: "question",
                title: "Suppression",
                html: "Etes-vous sûr de vouloir supprimer ce fichier ?<br/>[" + id + "] " + title,
                showCancelButton: true,
                confirmButtonColor: "#28a745",
                cancelButtonColor: "#dc3545",
                confirmButtonText: "Oui",
                cancelButtonText: "Non",
            }).then((result) => {
                if (result.value) {
                    Swal.fire({
                        title: 'Suppression du Fichier en cours...',
                        didOpen: () => { Swal.showLoading() }
                    });

                    var req = { fileID: id, fileTypeID: parseInt(file.fileTypeID), bindID: parseInt(file.bindID), bindType: entity, OpName: "REMOVE_" + entity + "FILE", isPermanent: true };
                    if (file.categ) req.ftype = file.categ;
                    req.waitForCompletion = false;
                    if (req.fileID && req.bindID) {
                        commonFunc.postMethod("../api/" + entity + "/Remove" + entity + "File", req).then((response) => {
                            var data = response.data;
                            Swal.close();
                            if (data && data.isSuccess) {
                                manageFiles(null, null, false, (newFiles) => {
                                    createTreeFolder(newFiles);
                                });
                            } else {
                                Swal.fire({
                                    icon: "error",
                                    title: "Echec",
                                    html: "Echec de Suppression :<br>" + data.errorMessage
                                });
                            }
                        });
                    }
                    else {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: "Echec de Suppression : Arguments invalides"
                        });
                    }
                }
            });
        }
    }

    function addFolder(dataFolder) {
        Swal.fire({
            title: "Nouveau dossier",
            html: (dataFolder ? ("Sera créé dans le dossier " + dataFolder.name) : "") + "<br/><input id='swal2-input' class='swal2-input' placeholder='Entrez le nom du dossier' type='text' autoComplete='off' aria-autocomplete='none' style='display: flex;'><br><input id='create-for-all' type='checkbox' /> <label for='create-for-all'><i class='fa fa-folder-tree me-2'></i>" + context.props.i18nManager.t("folder.createFolderAllTree") + "</label>",
            customClass: {
                popup: "cswal-input p-3"
            },
            /*text: dataFolder ? ("Sera créé dans le dossier " + dataFolder.name) : "",
            input: "text",
            inputPlaceholder: "Nom du dossier",*/
            showCancelButton: true,
            confirmButtonText: "Créer le dossier",
            cancelButtonText: "Annuler",
            confirmButtonColor: "#28a745",
            cancelButtonColor: "#dc3545",
            preConfirm: () => {
                var inputCode = document.getElementById("swal2-input");
                var createForAll = document.getElementById("create-for-all");
                if (!inputCode.value) {
                    Swal.showValidationMessage("Veuillez saisir un nom");
                    return false;
                }
                else if (inputCode.value === "Sites" ||inputCode.value === "Fichiers" || inputCode.value.indexOf("Fichiers/") >= 0 || inputCode.value.indexOf("Fichiers\\") >= 0) {
                    Swal.showValidationMessage("Veuillez saisir un nom valide");
                    return false;
                }

                return { "inputValue": inputCode.value, "checked": (createForAll?.checked || false) };
            }
        }).then((result) => {
            if (result.value) {
                //TODO
                //var mode = "";
                var fullPath = dataFolder?.fullPath || "";
                var entityPath = dataFolder?.entityPath || "";
                var bindID = dataFolder?.siteID || -1;
                /*var cascadeChildren = false;
                if (mode === "commonSites") {
                    bindID = -1;
                }
                else if (mode === "commonParent") {
                    bindID = -1;
                    cascadeChildren = true;
                }*/
                commonFunc.postMethod("../api/data/CreateFolder", { name: result.value.inputValue, bindID: bindID, cascadeChildren: result.value.checked, entity: entityPath/*entity*/, prefix: fullPath }).then((response) => {
                    if (response.data && response.data.isSuccess) {

                        manageFiles(null, null, false, (newFiles) => {
                            createTreeFolder(newFiles);
                        });

                        /*if (dataFolder) {
                            dataFolder.subFolders.push();
                        }
                        else {
                            folders.push();
                        }*/

                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: "Echec de l'ajout de dossier<br/>" + response.data.errorMessage
                        });
                    }
                });
            }
        });
    }

    function removeFolder(dataFolder) {
        Swal.fire({
            icon: "warning",
            title: "Action impossible",
            html: "Veuillez contacter le support pour effectuer une suppression"
        });
        return;
        Swal.fire({
            icon: "question",
            title: "Suppression Répertoire",
            html: "Etes-vous sûr de vouloir supprimer ce répertoire ?<br/>[" + dataFolder.fullPath + "] " + dataFolder.name,
            showCancelButton: true,
            confirmButtonColor: "#28a745",
            cancelButtonColor: "#dc3545",
            confirmButtonText: "Oui",
            cancelButtonText: "Non",
        }).then((result) => {
            if (result.value) {
                Swal.fire({
                    title: 'Suppression du Répertoire en cours...',
                    didOpen: () => { Swal.showLoading() }
                });
                commonFunc.postMethod("../api/data/RemoveFolder", dataFolder).then((response) => {
                    var data = response.data;
                    Swal.close();
                    if (data?.isSuccess) {
                        //TODO : voir si reloadFolders ou pas
                        var splittedPath = dataFolder.fullPath.split("\\");

                        var parentPath = dataFolder.fullPath.replace("\\" + splittedPath[splittedPath.length - 1], "");

                        var parentFolder = commonFunc.getValue(foldersTreeState, (parentPath || ""));
                        if (parentFolder.children) {
                            parentFolder.children = parentFolder.children.filter((folder) => {
                                return folder !== dataFolder;
                            });
                        }

                        manageFiles();
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: "Echec de Suppression<br/>" + data.errorMessage
                        });
                    }
                });
            }
        });
    }

    function searchFiles(e) {
        if (e.target?.value.length >= 4 || context.state.searchValue?.length) {
            var idRq = parseInt(Math.floor(Date.now() + Math.random() * 1000000000000001).toString().substring(6));
            lastSearchReq.current = idRq;
            setTimeout(() => {
                if (lastSearchReq.current === idRq) {
                    var newValue = e.target?.value.length >= 4 ? e.target?.value : "";
                    manageFiles(newValue);
                }
            }, 1000);
        }
    }

    var jsonFiles = sessionStorage.getItem('manageFilesList');
    var filesList = JSON.parse(jsonFiles) || [];

    //Gestion SelectedFile
    var selectedFile;
    //var filteredSFile = filesList?.filter(file => file.idFile === selectedFileID);
    var filteredSFile = context.state.files?.filter(file => file.idFile === selectedFileID);
    if (filteredSFile?.length) selectedFile = filteredSFile[0];

    var selectedFolder = commonFunc.getValue(foldersTreeState, (selectedFolderPath || ""));
    var isSearch = !selectedFolder && selectedFolderPath;
    if (isSearch) selectedFolder = searchData;

    var filePath;
    var filePathDirectDl;
    if (selectedFile) {
        const file = {
            fileId: selectedFile.idFile,
            fileName: selectedFile.name,
            container: selectedFile.rootContainer,
            etag: selectedFile.etag,
            accessToken: selectedFile.absoluteUri,
            newWindow: false
        };
        filePath = "/api/data/DownloadFileByUri?" + commonFunc.toParams(file);
        if (selectedFile.instanceFile) filePath = selectedFile.instanceFile.preview;

        file.newWindow = true;
        filePathDirectDl = "../api/data/DownloadFileByUri?" + commonFunc.toParams(file);
    }
    var fileIcon = selectedFile ? commonFunc.getFilesFaIcon(selectedFile.name, selectedFile.categ) : null;
    var isPicture = fileIcon?.props["data-typef"] === "img";
    var isPDF = selectedFile?.contentType === "application/pdf";



    //var sortedFiles = filesList?.length ? [...filesList] : [];
    var sortedFiles = context.state.files?.length ? [...context.state.files] : [];

    //TODO : /!\ Incompatible avec la pagination back
    /*if (context.state.config?.includeEntities) {
        var splittedInclude = context.state.config.includeEntities.split(";");
        sortedFiles = sortedFiles.filter(file => {
            var flag = false;
            splittedInclude.forEach(item => {
                flag |= (!commonFunc.isBlank(item) && file.prefix?.indexOf("\\" + item + "\\") >= 0);
            });

            return flag;
        });
    }*/
    switch (filesSorting) {
        case "length":
            sortedFiles = sortedFiles.sort((a, b) => b.length - a.length);
            break;
        case "lengthInverse":
            sortedFiles = sortedFiles.sort((a, b) => a.length - b.length);
            break;
        case "dSysMod":
            sortedFiles = sortedFiles.sort((a, b) => { return new Date(b.dSysMod).getTime() - new Date(a.dSysMod).getTime(); });
            break;
        case "dSysModInverse":
            sortedFiles = sortedFiles.sort((a, b) => { return new Date(a.dSysMod).getTime() - new Date(b.dSysMod).getTime(); });
            break;
        case "name":
            sortedFiles = sortedFiles.sort((a, b) => a.name.localeCompare(b.name));
            break;
        case "nameInverse":
            sortedFiles = sortedFiles.sort((a, b) => b.name.localeCompare(a.name));
            break;
        default: break;
    }
    var filesCount = sortedFiles?.filter(file => file.categ !== "DIR").length || 0;

    var entities = context.state.config?.optionsEntities || [];

    var sorting = [{ value: "", label: "Aucun" }, { value: "length", label: "Taille ↓" }, { value: "lengthInverse", label: "Taille ↑" }, { value: "dSysMod", label: "Date ↓" }, { value: "dSysModInverse", label: "Date ↑" }, { value: "name", label: "Nom ↓" }, { value: "nameInverse", label: "Nom ↑" }];

    var cardFileProps = { xs: "12", sm: "3", md: "4", xl: "5" };
    if (selectedMode === "table") cardFileProps = { xs: "12", sm: "7", md: "8", xl: "9" };

    var displaySearch = isSearch;// !(!(commonFunc.isBlank(context.state.searchValue) && !selectedFolderPath) && selectedFolder?.children?.length);

    //Conditions pour création de répertoires
    var siteObj = context.props.getSite();
    var isAllowedManageFolder = selectedFolder?.depth >= 3 && (context.state.config?.allowCreateFolder?.indexOf("\\" + selectedFolder.entityPath + "\\" + selectedFolder.siteID + "\\;") >= 0 || context.state.config?.allowCreateFolder?.indexOf(selectedFolder.fullPath + ";") >= 0) && (!siteObj || !(siteObj.parentID > 0));

    //Gestion bouton details (doublon avec FileSpace)
    var curUser = context.props.getUser();
    var btnObj = { ...context.state.config?.filesCustomArgs, noRemove: true };
    if (btnObj.cNoRemoveExclusion) {
        var targetRoles = curUser?.roles ? curUser.roles[0] : null;
        btnObj.noRemove = btnObj.cNoRemoveExclusion.indexOf(targetRoles + ";") < 0;
    }
    else btnObj.noRemove = false;
    if (btnObj.cRestrictSubSite) {
        if (siteObj?.parentID > 0) {
            btnObj.noRemove = true;
            btnObj.onlyDelete = true;
        }
    }
    if ((!selectedFolderSiteID /*&& commonFunc.isBlank(context.state.searchValue)*/) || (btnObj.cLockMenu?.indexOf("\\" + selectedFolderSiteID + "\\;") >= 0 || btnObj.cLockMenu?.indexOf(selectedFolderPath + ";") >= 0)) {
        btnObj.noRemove = true;
        btnObj.onlyDelete = true;
    }


    return <div className="filespace-mfiles">
        {/* ========== STATS CARDS OSKALA ========== */}
        <div className="ged-stats-grid">
            <div className="ged-stat-card">
                <div className="ged-stat-info">
                    <span className="ged-stat-label">Total Documents</span>
                    <span className="ged-stat-value">{foldersState?.length ? foldersState[0].fileCount : 0}</span>
                    <span className="ged-stat-change positive"><i className="fa fa-file me-1"></i> Documents</span>
                </div>
                <div className="ged-stat-icon primary"><i className="fa fa-file-lines"></i></div>
            </div>
            <div className="ged-stat-card">
                <div className="ged-stat-info">
                    <span className="ged-stat-label">Espace Utilisé</span>
                    <span className="ged-stat-value">{foldersState?.length ? foldersState[0].sizeFormatted : "0 Ko"}</span>
                    <span className="ged-stat-change"><i className="fa fa-database me-1"></i> Stockage</span>
                </div>
                <div className="ged-stat-icon success"><i className="fa fa-hard-drive"></i></div>
            </div>
            <div className="ged-stat-card">
                <div className="ged-stat-info">
                    <span className="ged-stat-label">Dossiers</span>
                    <span className="ged-stat-value">{foldersState?.length ? foldersState[0].directoryCount : 1}</span>
                    <span className="ged-stat-change"><i className="fa fa-folder me-1"></i> Répertoires</span>
                </div>
                <div className="ged-stat-icon warning"><i className="fa fa-folder-tree"></i></div>
            </div>
            <div className="ged-stat-card">
                <div className="ged-stat-info">
                    <span className="ged-stat-label">Entités</span>
                    <span className="ged-stat-value">{foldersState?.length ? (foldersState[0].children?.length || 0) : 0}</span>
                    <span className="ged-stat-change"><i className="fa fa-building me-1"></i> Structures</span>
                </div>
                <div className="ged-stat-icon info"><i className="fa fa-sitemap"></i></div>
            </div>
        </div>

        <Row className="mb-2 d-none">
            <Col className="col-12 col-sm-auto align-items-end text-end d-flex">
                <div>
                    <Label>Trié par</Label>
                    <Select isMulti={false} className={``} defaultValue={filesSorting} onChange={(e, target) => {
                        setFilesSorting(e.value);
                    }} value={{ value: filesSorting, label: sorting.filter(item => item.value === filesSorting)[0].label }} options={sorting} />
                </div>
                {entities?.length ? <div>
                    <Label>Modules</Label>
                    <Select isMulti={true} className={``} placeholder="Tous" onChange={(e, target) => {
                        var list = context.state.entities;
                        if (target.action === "remove-value") {
                            list = list.filter(entity => entity.value !== target.removedValue.value);
                            context.setState({ entities: list });
                        }
                        else if (target.action === "select-option") {
                            list.push(target.option);
                            context.setState({ entities: [...list] });
                        }
                        else if (target.action === "clear") {
                            context.setState({ entities: [] });
                        }
                    }} options={entities} value={context.state.entities} />
                </div> : ""}
                <div className="text-secondary" style={{ fontSize: "12px" }}>TODO</div>
            </Col>
        </Row>

        <Row>
            <Col xs="12" sm="5" md="4" xl="3">
                <Card className="m-0 user-select-none" style={{ height: "72vh" }}>
                    <CardHeader className="ged-card-header-blue d-flex align-items-center p-3">
                        <i className="fa fa-folder me-2"></i>
                        <b style={{ flex: "auto" }}>Explorateur</b>
                        {context.props.checkRights("SITE_FILES", "A") ? <Button className="btn-simple btn-icon m-0 ms-2 d-none" style={{ color: "white" }} onClick={() => { addFolder(); }}><i className="fa fa-folder-plus"></i></Button> : ""}
                    </CardHeader>
                    <CardBody className="d-flex flex-column overflow-hidden" style={{}}>
                        <div className="text-secondary fw-bold mb-2" style={{ fontSize: "12px" }}><i className="far fa-star me-2"></i>{("Accès rapide").toUpperCase()}</div>
                        <Folder key={"folderHome"} data={{ name: "Derniers Documents", fileCount: 0 }} context={context} selectedFolderPath={selectedFolderPath} selectedFolderSiteID={selectedFolderSiteID} selectedFolderEntity={selectedFolderEntity}
                            setSelectedFolder={(data) => { if (!filesLoading) { setSelectedFolderPath(null); setSelectedFolderSiteID(null); setSelectedFolderEntity(null); document.getElementById("mfilesearch").value = ""; manageFiles(""); } }}
                            addFolder={addFolder} isRoot forcedSelection={commonFunc.isBlank(context.state.searchValue) && !selectedFolderPath} />
                        <Folder key={"folderSearch"} data={searchData} context={context} selectedFolderPath={selectedFolderPath} selectedFolderSiteID={selectedFolderSiteID} selectedFolderEntity={selectedFolderEntity}
                            setSelectedFolder={(data) => {
                                if (!filesLoading) {
                                    setSelectedFolderPath(data.fullPath);
                                    setSelectedFolderSiteID(parseInt(data.siteID) > 0 ? data.siteID : null);
                                    setSelectedFolderEntity(data.entityPath);
                                }
                            }} addFolder={addFolder} isSearch />
                        {/*(!commonFunc.isBlank(context.state.searchValue) && !selectedFolderPath) ? <Folder key={"folderSearch"} data={{ name: "Résultats de recherche", fileCount: 0 }} context={context} selectedFolderPath={selectedFolderPath} selectedFolderSiteID={selectedFolderSiteID} selectedFolderEntity={selectedFolderEntity}
                            setSelectedFolder={(data) => { }} addFolder={addFolder} isSearch forcedSelection={true} /> : ""*/}
                        <div className="text-secondary fw-bold mb-2 mt-2" style={{ fontSize: "12px" }}><i className="fa fa-folder-tree me-2"></i>{("Documents").toUpperCase()}</div>
                        <div className="folders-generated" style={{ overflowY: "auto", overflowX: "hidden" }}>{foldersState?.map((folder, index) => {
                            return <Folder key={"folder" + index + folder.name} data={folder} context={context} selectedFolderPath={selectedFolderPath} selectedFolderSiteID={selectedFolderSiteID} selectedFolderEntity={selectedFolderEntity}
                                setSelectedFolder={(data) => {
                                    if (!filesLoading) {
                                        setSelectedFolderPath(data.fullPath);
                                        setSelectedFolderSiteID(parseInt(data.siteID) > 0 ? data.siteID : null);
                                        setSelectedFolderEntity(data.entityPath);
                                    }
                                }} isAllowedManageFolder={isAllowedManageFolder} addFolder={addFolder} onRemoveFolder={(data) => { removeFolder(data); }} />
                        })}</div>
                    </CardBody>
                </Card>
            </Col>

            <Col {...cardFileProps}>
                <Card className="m-0 user-select-none" style={{ height: "72vh", backgroundColor: "rgba(30, 89, 115,0.05)" }}>
                    <CardHeader className="ged-card-header-blue d-flex align-items-center py-2">
                        <div className="d-flex align-items-center" style={{ flex: "auto" }}>
                            <div><b><i className="far fa-folder me-2"></i>{customFolderT(selectedFolder?.name || "Derniers Documents")}{""/*selectedFolderPath*/}
                                {selectedFolder?.depth >= 3 && selectedFolder?.tenantSite?.value ? <span className="ms-2 fw-normal" style={{ opacity: 0.8 }}>— {selectedFolder.tenantSite?.value} ({selectedFolder.tenantSite?.id})</span> : ""}</b></div>
                            <Button className="btn-simple btn-icon m-0 ms-2" style={{ color: "white", borderColor: "rgba(255,255,255,0.3)" }} onClick={() => {
                                manageFiles(null, null, false, (newFiles) => {
                                    createTreeFolder(newFiles);
                                });
                            }}><i className="fa fa-sync"></i></Button>
                            {context.props.checkRights("SITE_FILES", "A") && isAllowedManageFolder ? <Button className="btn-simple btn-icon m-0 ms-2" style={{ color: "white", borderColor: "rgba(255,255,255,0.3)" }} onClick={() => { addFolder(selectedFolder); }}><i className="fa fa-folder-plus"></i></Button> : ""}
                        </div>
                        <div className="d-flex align-items-center">
                            <div className={`me-2 ${displaySearch ? "" : "d-none"}`}>
                                <InputGroup className="">
                                    <InputGroupText style={{ background: "rgba(255,255,255,0.15)", borderColor: "rgba(255,255,255,0.3)", color: "white" }}>
                                        <i aria-hidden="true" className="fa fa-magnifying-glass"></i>
                                    </InputGroupText>
                                    <Input type="search" autoComplete="off" aria-autocomplete="none" name="mfile-search" id="mfilesearch" placeholder="Recherche" onInput={(e) => searchFiles(e)} style={{ background: "rgba(255,255,255,0.15)", borderColor: "rgba(255,255,255,0.3)", color: "white" }} />
                                </InputGroup>
                            </div>
                            <ButtonGroup>
                                <Button className={`btn-sm ${selectedMode === "list" ? "active" : ""}`} style={{ color: "white", borderColor: "rgba(255,255,255,0.4)", background: selectedMode === "list" ? "rgba(255,255,255,0.25)" : "transparent" }} onClick={() => { setSelectedMode("list"); setSelectedFileID(null); }}><i className="fa fa-list"></i> Liste</Button>
                                <Button className={`btn-sm ${selectedMode === "table" ? "active" : ""}`} style={{ color: "white", borderColor: "rgba(255,255,255,0.4)", background: selectedMode === "table" ? "rgba(255,255,255,0.25)" : "transparent" }} onClick={() => { setSelectedMode("table"); setSelectedFileID(null); }}><i className="fa fa-table"></i> Tableau</Button>
                            </ButtonGroup>
                        </div>
                    </CardHeader>
                    <CardBody className="position-relative pt-0">
                        {filesLoading ? <div className="text-center align-content-center mt-2"><i className="fa fa-circle-notch fa-spin fa-2x"></i></div> : ""}
                        <FileSpace {...props} supClass={`${filesLoading ? "d-none" : ""}`} files={sortedFiles} filesCount={filesCount} selectedFolder={selectedFolder} selectedFolderEntity={selectedFolderEntity} selectedFolderSiteID={selectedFolderSiteID} selectedFolderPath={selectedFolderPath}
                            selectedMode={selectedMode} selectedFile={selectedFile} selectFile={selectFile} manageFiles={manageFiles} createTreeFolder={createTreeFolder} />
                    </CardBody>
                    <div className="clearfix d-flex me-2">
                        <div className="flex-fill text-end">
                            {(() => {
                                var pagesList = [];
                                if (maxPages > 1) {
                                    pagesList.push(1);
                                    var currChildCount = 1;
                                    var countPage = 3;
                                    var currCountPage = 3;
                                    var appendEnd = false;
                                    var minPage = (currentPage - (countPage - currChildCount)) > 1 ? (currentPage - (countPage - currChildCount)) : 2;
                                    if (minPage > 2 && maxPages > countPage + (currChildCount + 1)) {
                                        pagesList.push("...");
                                        currCountPage--;
                                        minPage++;
                                    }
                                    if (minPage > (maxPages - countPage - 1) && (maxPages - ((currChildCount * 2) + 2)) > 0) minPage = (maxPages - ((currChildCount * 2) + 2));
                                    if (minPage <= 1) minPage = 2;
                                    if (minPage <= maxPages) {
                                        var currMaxPage;
                                        if ((minPage + countPage + 2) > maxPages) {
                                            currMaxPage = (maxPages > 2 ? maxPages - 1 : maxPages);
                                        }
                                        else {
                                            currMaxPage = (minPage + currCountPage);
                                            currCountPage--;
                                            appendEnd = true;
                                        }
                                        for (var i = minPage; i <= currMaxPage; i++) {
                                            pagesList.push(i);
                                        }
                                        if (appendEnd) pagesList.push("...");
                                    }
                                    if (maxPages > currMaxPage) pagesList.push(maxPages);
                                }
                                return pagesList.length ? <>
                                    <Button className={`btn-icon btn-round ${(currentPage - 1) < 1 ? "disabled" : ""}`} size="sm" color="secondary" onClick={(e) => { setCurrentPage(currentPage - 1); }}><i className="fa fa-chevron-left"></i></Button>
                                    {pagesList.map(i => <Button className={`btn-icon btn-round ${i === "..." ? "disabled" : ""}`} size="sm" color={i === currentPage ? "primary" : "secondary"} onClick={(e) => { setCurrentPage(i); }}>{i}</Button>)}
                                    <Button className={`btn-icon btn-round ${(currentPage + 1) > maxPages ? "disabled" : ""}`} size="sm" color="secondary" onClick={(e) => { setCurrentPage(currentPage + 1); }}><i className="fa fa-chevron-right"></i></Button>
                                </> : "";
                            })()}
                            <div className="mb-1">
                                <span id="aupdActFilesCount" className="badge bg-primary me-1">{filesCount} Fichier(s) {dataCount > 0 && dataCount !== filesCount ? " (" + dataCount + ")" : ""}</span>
                                {selectedFolder?.size > 0 ? <span id="aupdActFilesSize" className="badge bg-info me-1">{selectedFolder?.sizeFormatted || commonFunc.bytesToSize(selectedFolder?.size, 1)}</span> : ""}
                            </div>
                        </div>
                    </div>
                </Card>
            </Col>

            {detailsLoading ? <Col xs="4" className="text-center align-content-center" style={{ height: "72vh" }}><i className="fa fa-circle-notch fa-spin fa-2x"></i></Col> : ""}
            {selectedFile && selectedMode !== "table" ? <Col xs="4">
                <Card className="m-0" style={{ height: "72vh", display: "flex", flexDirection: "column" }}>
                    <CardHeader className="ged-card-header-gradient" style={{ flexShrink: 0 }}>
                        <b>
                            <i className="fa fa-circle-info me-2"></i>Détails

                            <div className="ged-btn-section">
                                <Button className="btn-simple btn-icon m-0" style={{ color: "white", borderColor: "rgba(255,255,255,0.3)" }} onClick={() => { window.open(filePathDirectDl, '_newself'); }}><i className="fa fa-download"></i></Button>
                                {!btnObj.noRemove && <Button className="btn-simple btn-icon m-0 ms-2" style={{ color: "white", borderColor: "rgba(255,255,255,0.3)" }} onClick={() => { removeFile(selectedFile) }}><i className="fa fa-trash"></i></Button>}
                            </div>
                        </b>
                    </CardHeader>
                    <CardBody className="p-0 d-flex flex-column" style={{ flex: 1, overflow: "hidden" }}>
                        {/* Section Informations */}
                        <div className="ged-info-section" style={{ flexShrink: 0 }}>
                            <div className="ged-info-section-title d-none">Informations</div>
                            <div className="ged-detail-row">
                                <div className="ged-detail-label">Nom</div>
                                <div className="ged-detail-value fw-bold">{selectedFile.name}</div>
                            </div>
                            <div className="ged-detail-row">
                                <div className="ged-detail-label">Taille</div>
                                <div className="ged-detail-value">{commonFunc.bytesToSize(selectedFile.length, 1)}</div>
                            </div>
                            <div className="ged-detail-row">
                                <div className="ged-detail-label">Créé par</div>
                                <div className="ged-detail-value">{selectedFile.tenantUser?.value}</div>
                            </div>
                            <div className="ged-detail-row">
                                <div className="ged-detail-label">Date création</div>
                                <div className="ged-detail-value">{selectedFile.dSysMod ? (commonFunc.formatDateTime(selectedFile.dSysMod instanceof Date ? selectedFile.dSysMod : moment(commonFunc.restStringToDate(selectedFile.dSysMod)).utc(true).toDate())) : "."}</div>
                            </div>
                            <div className="ged-detail-row">
                                <div className="ged-detail-label">Catégorie</div>
                                <div className={`badge ged-badge-${(selectedFile.categ || '').toLowerCase()}`}>{selectedFile.fileType?.value + " (" + selectedFile.categ + ")"}</div>
                            </div>
                            {selectedFile.tenantSite ? <div className="ged-detail-row">
                                <div className="ged-detail-label">Rattachement</div>
                                <div className="ged-detail-value">{selectedFile.tenantSite.value + " (" + selectedFile.tenantSite.id + ")"}</div>
                            </div> : ""}
                        </div>

                        {/* Section Aperçu - prend tout l'espace restant */}
                        {(isPicture || isPDF) ? <div className="ged-preview-section" style={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
                            <div className="ged-info-section-title d-none" style={{ flexShrink: 0 }}>Aperçu</div>
                            <div className="ged-preview-frame d-block" style={{ flex: 1, minHeight: "200px" }}>
                                {isPicture ? <Img style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }} className='img-responsive' src={selectedFile.instanceFile ? selectedFile.instanceFile.preview : filePath} alt='' /> : ""}
                                {isPDF ? <PdfViewer url={filePath} containerId="embdActFinalPDf" shouldRender={true} pagemode={"none"} zoom={"page-width"} style={{ width: "100%", height: "100%" }}></PdfViewer> : ""}
                            </div>
                        </div> : ""}
                    </CardBody>
                </Card>

                <Card className="m-0 d-none">
                    <CardHeader className="p-3 text-dark" data-background-color="true">
                        <i className="fa fa-history me-2"></i> <b>Activité</b>
                    </CardHeader>
                    <CardBody>
                        TODO
                    </CardBody>
                </Card>
            </Col> : ""}
        </Row>
    </div>;
}

function FileSpace(props) {
    var { context, entity, defaultFileType, files, filesCount, selectedMode, selectedFolder, selectedFolderEntity, selectedFolderSiteID, selectedFolderPath, selectedFile, selectFile, manageFiles, createTreeFolder } = props;

    var filesType = [];

    const [fileType, setFileType] = React.useState(defaultFileType || "");
    const [fileTypeId, setFileTypeId] = React.useState((filesType && defaultFileType) ? () => {
        var typesFiltered = filesType.filter(type => type.refExtID === defaultFileType);
        if (typesFiltered.length) {
            return typesFiltered[0].idFileType || 0;
        }
        else {
            return 0;
        }
    } : 0);


    var curUser = context.props.getUser();

    var filesAltObj = { ...context.state.config?.filesCustomArgs, noRemove: true };
    if (context.filesType) filesAltObj.filesType = context.filesType;
    else filesAltObj.altFilesTypes = "../api/" + entity + "/Get" + entity + "FilesType";

    //filesAltObj.files = files/*?.map(file => file.file.categ !== "RCP" ? file.file : null).filter(file => file !== null)*/ || [];
    filesAltObj.files = files/*?.filter(file => {
        var splittedFullPath = file.prefix.split("\\");
        return (!selectedFolderEntity || splittedFullPath[1] === selectedFolderEntity) && (!selectedFolderSiteID || file.siteID === selectedFolderSiteID) && (!selectedFolderPath || file.prefix.indexOf(selectedFolderPath) >= 0);
    })*/;

    filesAltObj.setFiles = (cptFiles) => {
        console.debug("refresh");

        manageFiles(null, null, false, (newFiles) => {
            createTreeFolder(newFiles);
        });
    };

    if (!commonFunc.isBlank(selectedFolderPath)) filesAltObj.customPath = selectedFolderPath;
    if (filesAltObj.cNoRemoveExclusion) {
        var targetRoles = curUser?.roles ? curUser.roles[0] : null;
        filesAltObj.noRemove = filesAltObj.cNoRemoveExclusion.indexOf(targetRoles + ";") < 0;
    }
    else filesAltObj.noRemove = false;

    var preventUpload = false
    if (filesAltObj.cRestrictSubSite) {
        var siteObj = context.props.getSite();
        if (siteObj?.parentID > 0) {
            filesAltObj.noRemove = true;
            filesAltObj.onlyDelete = true;
            preventUpload = parseInt(selectedFolderSiteID) !== siteObj.idSite;
        }
    }
    if ((!selectedFolderSiteID /*&& commonFunc.isBlank(context.state.searchValue)*/) || (filesAltObj.cLockMenu?.indexOf("\\" + selectedFolderSiteID + "\\;") >= 0 || filesAltObj.cLockMenu?.indexOf(selectedFolderPath + ";") >= 0)) {
        filesAltObj.noRemove = true;
        filesAltObj.onlyDelete = true;
        preventUpload = true;
    }


    var uploadTypes = props.accept || props.parentProps?.accept || {};

    var isSiteContext = selectedFolderEntity === "Sites" && parseInt(selectedFolderSiteID) > 0;
    var manageUpload = isSiteContext /*&& parseInt(selectedFolderSiteID) === curUser?.groupSId*/ && !preventUpload
        && !selectedFolderPath?.endsWith("\\" + selectedFolderSiteID) && (!selectedFolder || selectedFolder.children <= 0);//Contrainte test sur SiteID pour éviter l'upload de fichiers dans mauvais siteID

    return <div className={`text-start ${props.supClass}`}>
        {false ? <Dropzone accept={uploadTypes}
            maxFiles={props.parentProps?.maxFiles || 0}
            //maxSize={props.parentProps.maxSize || 14990000}//Infinity
            noClick
            noKeyboard
            noDragEventsBubbling
            preventDropOnDocument={false}
            onDrop={(acceptedFiles, fileRejections, e) => {
                if (e) e.target.classList.remove("hover");

                acceptedFiles.forEach((file) => {
                    const reader = new FileReader()

                    reader.onabort = () => console.log('file reading was aborted')
                    reader.onerror = () => console.log('file reading has failed')
                    reader.onload = () => {
                        // Do whatever you want with the file contents
                        const binaryStr = reader.result
                        console.log(binaryStr)
                    }
                    reader.readAsArrayBuffer(file)
                });

                if (fileRejections && fileRejections.length) {
                    Swal.fire({
                        icon: "warning",
                        title: "Attention",
                        html: "Certains fichiers ne peuvent pas être uploadé :<br/>" + fileRejections.map(file => "<div title='" + file.errors.map(error => error.message.replace("Too many files", "Trop de fichiers").replace("File is larger than", "Fichiers trop volumineux : ").replace("bytes", "octets max") + "\n") + "'>" + file.file.name + "<i class='fa fa-2xs fa-circle-info'></i></div>")
                    });
                }

                var newFiles = acceptedFiles.map(file => Object.assign(file, {
                    preview: URL.createObjectURL(file),
                    docType: file.docType || fileType,
                    docTypeId: file.docTypeId || fileTypeId,
                }));
                if (!props.parentProps?.maxFiles || ((newFiles?.length || 0) <= props.parentProps?.maxFiles)) {
                    //newFiles = newFiles.concat(localFiles);
                    //setLocalFiles(newFiles);
                    //setRerender(!rerender);



                    var modalRoot;

                    //Traitement des informations retourné par le Dialog
                    var callbackModal = function (modalFiles) {
                        console.debug(modalFiles);

                        //setFiles(modalFiles);

                        /*if (globalProps.files) {
                            var newFiles = globalProps.files;
                            modalFiles.forEach(file => {
                                console.debug(file);
                                var tempID = parseInt(Math.floor(Date.now() + Math.random() * 1000000000000001).toString().substring(6));
                                if (globalProps.noUploads) newFiles.push({ idFile: tempID, name: file.name, instanceFile: file, dSysMod: file.lastModifiedDate, prefix: file.docType, length: file.size, categ: file.docType });
                                else if (file.responseData) newFiles.push(file.responseData.result);
                            });
                            if (globalProps.setFiles) globalProps.setFiles(newFiles);
                        }
                        if (globalProps.resetAfterUpload) globalProps.files.length = 0;
                        else loadFiles();*/

                        manageFiles(null, null, false, (newFiles) => {
                            createTreeFolder(newFiles);
                        });

                        modalRoot.unmount();
                    };

                    modalRoot = createRoot(document.createElement('div'));
                    /*modalRoot.render(<FileUploadModal parentProps={globalProps} title={globalProps.customTitle || ("Transfert de Fichiers " + (globalProps.srcName || ""))} defaultFileType={globalProps.defaultFileType} fileTypeID={globalProps.fileTypeID} bindID={globalProps.bindID}
                        waitForCompletion={globalProps.waitForCompletion} files={newFiles} callback={callbackModal}></FileUploadModal>);*/

                    modalRoot.render(<FileUploadModal files={newFiles} parentProps={{
                        uploadAutoClose: true, noChooseTypes: false, noUploads: false, /*accept: { "application/pdf": [".pdf"] },*/
                        altFilesTypes: "../api/" + entity + "/Get" + entity + "FilesType", altUploadFilesUrl: "../api/" + entity + "/Upload" + entity + "Files"
                    }} title={"Upload Fichiers"} defaultFileType={fileType} fileTypeID={entity} bindID={selectedFolderSiteID} callback={callbackModal}></FileUploadModal>);


                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: "Echec",
                        html: "Nombre de fichiers maximum dépassé"
                    });
                }
            }}
            onDragEnter={(e) => {
                e.target.classList.add("hover");
            }}
            onDragLeave={(e) => {
                e.target.classList.remove("hover");
            }}
        >
            {({ acceptedFiles, getRootProps, getInputProps, open, rootRef, inputRef, isFocused }) => {

                return (
                    <section className="ged-dropzone-wrapper">
                        <div {...getRootProps()} className="ged-dropzone">
                            <input {...getInputProps()} />
                            <div className="ged-dropzone-content text-center" style={{ padding: "40px 20px" }}>
                                <i className="fa fa-cloud-arrow-up fa-3x mb-3" style={{ color: "#00aaa8" }}></i>
                                <div className="fw-semibold mb-1">Glissez-déposez vos fichiers ici</div>
                                <div className="text-muted small">ou cliquez pour parcourir</div>
                            </div>
                        </div>
                    </section>
                );
            }}
        </Dropzone> : ""}


        <Row className={`mt-2 ${manageUpload ? "" : "noDrop"}`}>
            <Col xs="12">
                <div className="position-relative">
                    <FilesCustom key={"fc" + selectedFolderPath} className={`mf-files`} bindID={parseInt(selectedFolderSiteID) || parseInt(selectedFile?.tenantSite?.id) || -1} rightType={entity + "_FILES"} checkRights={context.props.checkRights} fileTypeID={entity} src={null} onFileClick={(file, node) => { if (selectedMode !== "table") selectFile(file) }} onFileDblClick={(file, node) => { if (selectedMode === "table") selectFile(file, true) }}
                        srcName={selectedFolderPath} shouldRender noPreview noUploadBtn={true} tableRendering={selectedMode === "table"} listRendering={selectedMode === "list"} defaultFileType={fileType} checkProps {...filesAltObj}
                        models={context.state.modelsList} noAltActions withDropzone={manageUpload} noChooseTypesTODO noTimestamp defaultTimestamp={false} notSyncableFilesType={true} excludedFilesTypes={["DIR", "VFA", "VFR", "VCG", "VCD", "AVA", "CTG"]}
                        placeHolder={filesCount <= 0 ? <div className={`position-absolute text-center fw-bold ${selectedMode === "table" ? "d-none" : ""}`} style={{ top: "60px", right: "0px", left: "0px", color: "#6c757d8f" }}><i className="fa fa-folder-open fa-6x"></i><h4>Aucun Fichier</h4></div> : ""}
                        altFilesUrl={"../api/" + entity + "/Get" + entity + "Files"} altRemoveFilesUrl={"../api/" + entity + "/Remove" + entity + "File"} altUploadFilesUrl={"../api/" + entity + "/Upload" + entity + "Files"} />

                </div>
            </Col>
        </Row>
    </div>;
}

function Folder(props) {
    var { data, context, selectedFolderEntity, selectedFolderSiteID, selectedFolderPath, isRoot, isSearch, forcedSelection, isAllowedManageFolder, onRemoveFolder } = props;

    var altT = (label, args) => { return (label && label.startsWith("i18n:")) ? context.props.i18nManager.t(label.replace("i18n:", ""), args) : label };
    var customFolderT = (label, args) => { return (label && context.props.i18nManager.t("folder." + label) !== "folder." + label) ? context.props.i18nManager.t("folder." + label) : label };

    const [collapsed, setCollapsed] = React.useState(props.childOpenChain ? false : (context.state.config?.folderDefaultOpen ? !(context.state.config.folderDefaultOpen.indexOf(data.fullPath + ";") >= 0) : true));
    const [childOpenChain, setChildOpenChain] = React.useState(props.childOpenChain);

    data.functionManager = { setCollapsed: manageCollapsed };

    function manageCollapsed(newCollapsed, isChained) {
        setCollapsed(newCollapsed);
        if (!newCollapsed && (isChained || context.state.config?.folderChildsOpen === data.depth)) {
            setChildOpenChain(true);
            data.children?.forEach(child => {
                child.functionManager?.setCollapsed(newCollapsed, true);
            });
        }
        else setChildOpenChain(false);
    }

    var hasSubs = data.children?.length;
    var selected = forcedSelection || (selectedFolderEntity === data.entityPath && ((data.siteID === -1 && !selectedFolderSiteID) || selectedFolderSiteID === data.siteID) && selectedFolderPath === data.fullPath);

    var isEntityFolder = data.depth === 2;
    var isSiteFolder = data.depth === 3 && data.fullPath?.indexOf("\\Sites\\") >= 0;

    var isEntityChildOpenChain = (data.depth === 2 && data.children?.length <= (context.state.config?.folderNumAutoOpen || 1));

    return <div className="ms-2">
        <div className={`folder-container d-flex cursor-pointer align-items-center px-1`} style={selected ? { backgroundColor: "#AAAAAA66", borderRadius: "5px" } : {}} onClick={() => {
            if (hasSubs) manageCollapsed(false);
            props.setSelectedFolder(data);
        }} onContextMenu={(e) => {
            e.preventDefault();
            if (isAllowedManageFolder && data.depth >= 4 && data.name !== "Fichiers" && onRemoveFolder) {
                if (context.props.checkRights("SITE_FILES", "A")) {
                    if (data.directoryCount === 0 && data.fileCount === 0) {
                        onRemoveFolder(data);
                    }
                    else {
                        Swal.fire({
                            icon: "warning",
                            title: "Attention",
                            html: "Le répertoire contient encore des éléments"
                        });
                    }
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: "Erreur",
                        html: "Action non autorisé : Droits insuffisant"
                    });
                }
            }
            else {
                e.target.closest(".folder-container").classList.add("animate__animated", "animate__shakeX");
                setTimeout(() => {
                    e.target.closest(".folder-container").classList.remove("animate__animated", "animate__shakeX");
                }, 300);
            }
        }}>
            <span className={`${hasSubs ? "" : "invisible"}`} onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                manageCollapsed(!collapsed);
                props.setSelectedFolder(data);
            }}>{(collapsed ? <i className="fa fa-angle-right me-1 mt-1 text-muted" style={{ width: "10px" }}></i> : <i className="fa fa-angle-down me-1 mt-1" style={{ width: "10px" }}></i>)}</span>
            {isRoot ? <><i className="fa fa-house-chimney text-primary me-1"></i> <b><span style={{ flex: "auto" }}>{data.name}</span></b></>
                : (isSearch ? <><i className="fa fa-search text-info me-1"></i> <b><span style={{ flex: "auto" }}>{data.name}</span></b></>
                    : <><i className={`${isEntityFolder ? "fa fa-layer-group text-primary" : (isSiteFolder ? "fa " + (data.tenantSite?.tag === "Siege" ? "fa-landmark text-success" : "fa-building text-secondary") : "far fa-folder text-warning")} me-1`}></i> {isSiteFolder ? <span style={{ flex: "auto" }}>{data.tenantSite?.value}</span> : <span style={{ flex: "auto" }}>{customFolderT(data.name)}</span>}</>)}
            {data.fileCount > 0 ? <Badge className="float-end text-dark" color="light">{data.fileCount}</Badge> : ""}
            {context.props.checkRights("SITE_FILES", "A") ? <Button className="btn-round m-0 ms-1 p-0 d-none" color="primary" onClick={() => { props.addFolder(data); }} style={{ width: "15px", height: "15px" }}><i className="fa fa-folder-plus m-0"></i></Button> : ""}
        </div>

        {!collapsed ? <>
            {data.children?.map((subFolder, index) => <Folder {...props} key={"subFolder" + data.name + index + subFolder.name} data={subFolder} childOpenChain={childOpenChain || isEntityChildOpenChain} />)}
        </> : ""}
    </div>;
}